"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tooltipOptions = void 0;
exports.tooltipOptions = {
    displayColors: true,
    caretSize: 10,
    caretPadding: 2,
    cornerRadius: 4,
    backgroundColor: '#18333C',
    bodyFontColor: '#FFFFFF',
    bodyFontFamily: 'museo-sans, sans-serif',
    bodyFontStyle: 'normal',
    bodyFontSize: 12,
    titleFontColor: '#FFFFFF',
    titleFontFamily: 'museo-sans, sans-serif',
    titleFontStyle: 'normal',
    titleFontSize: 12,
    footerFontColor: '#FFFFFF',
    footerFontFamily: 'museo-sans, sans-serif',
    footerFontStyle: 'normal',
    footerFontSize: 12,
    callbacks: {
        title: function () { return ''; }
    }
};
//# sourceMappingURL=chart.js.map